import TwoColumnWithDesktopSidebar from './TwoColumnWithDesktopSidebar';

export default TwoColumnWithDesktopSidebar;
